export interface Review {
  id: string;
  rating: number;
  title: string;
  author: string;
  date: string;
  content: string;
}

export const reviews: Review[] = [
  {
    id: "jennygirrr-1",
    rating: 4,
    title: "So fun! Room for improvement",
    author: "Jennygirrr",
    date: "2026-03-24",
    content: "I love this game! It's very addicting and fun to \"buy\" homes I'll never be able to afford lol. The main problem I have is that it is limited to Texas and Canada. I would enjoy it significantly more if my hometown or a dream city were included soon."
  },
  {
    id: "yahs27-1",
    rating: 5,
    title: "Addicting",
    author: "yahs27",
    date: "2026-03-23",
    content: "A great way to learn more about real-estate prices as I look into buying my first home. Intuitive UI/UX and fun!"
  },
  {
    id: "rongef-1",
    rating: 5,
    title: "Most Addictive and Fun Game I've Ever Played",
    author: "rongef",
    date: "2026-03-23",
    content: "If you ever dreamed of building a real estate empire, this game makes it feel REAL. The use of real houses makes it so realistic, and the progression system keeps you constantly hooked. I love touring the houses and also getting design ideas. My kids also fell in love with it and learning real life concepts of remodeling to raise property value, rent income etc. This is awesome!"
  },
  {
    id: "itayush-1",
    rating: 5,
    title: "A great one",
    author: "Itayush",
    date: "2026-03-18",
    content: "I downloaded this game about a week ago and I can't get enough! Its the first game that I can really get into in a long time"
  },
  {
    id: "randomnicknameaaa-1",
    rating: 5,
    title: "Love it!",
    author: "RandomNickNameaaa",
    date: "2026-03-20",
    content: "Makes me want to be a flipper. My favorite part is the renovation and guessing the prices. It’s crazy you play with real properties you slowly understand more on realestat cost"
  },
  {
    id: "lifeofkaush-1",
    rating: 5,
    title: "Really fun game!",
    author: "lifeofkaush",
    date: "2026-03-20",
    content: "Really enjoying playing this game with my partner and it’s more fun than browsing homes on Zillow, can’t get enough!"
  },
  {
    id: "nanzzzu-1",
    rating: 5,
    title: "Househunt",
    author: "nanzzzu",
    date: "2026-03-19",
    content: "Super fun to see all the insane mansions in my city!"
  },
  {
    id: "zmoney6384947267-1",
    rating: 5,
    title: "Amazing Game!",
    author: "Zmoney6384947267",
    date: "2026-03-18",
    content: "This is such a fun game. Was super easy to get started and was awesome to see my real estate empire grow. Really nice design too. Recommend for anyone who finds themselves scrolling Zillow or Redfin all the time 🤣"
  },
  {
    id: "mmaker-1",
    rating: 5,
    title: "Fun to play with real homes",
    author: "mmaker.",
    date: "2026-03-18",
    content: "Such an amazing and productive game!"
  },
  {
    id: "fasterthanurgrandma-1",
    rating: 5,
    title: "Fun and educational",
    author: "fasterthanurgrandma",
    date: "2026-03-18",
    content: "I feel like I’m learning about the housing market in my area and having so much fun at the same time"
  },
  {
    id: "eranvaizel-1",
    rating: 5,
    title: "So much fun",
    author: "Eranvaizel",
    date: "2026-03-18",
    content: "Can’t get enough of this game, highly addictive!"
  },
  {
    id: "iskauf01-1",
    rating: 5,
    title: "Super Addictive",
    author: "Iskauf01",
    date: "2026-03-18",
    content: "Great way to learn about local markets and have fun at the same time!"
  },
  {
    id: "justonemorelvl-1",
    rating: 5,
    title: "Cool game!",
    author: "JustOneMoreLvl",
    date: "2026-03-18",
    content: "This game is impossible to put down! Wrapped up my first city and I'm already itching to get through all the others."
  },
  {
    id: "udi-dudi-1",
    rating: 5,
    title: "What an awesome and unique game",
    author: "Udi-Dudi",
    date: "2026-03-18",
    content: "This is such a fun game!! I love playing in real houses, it’s so different and unique. Love it!"
  },
  {
    id: "zainbacchus-1",
    rating: 5,
    title: "Extremely fun",
    author: "zainbacchus",
    date: "2026-03-18",
    content: "I downloaded this game recently and cant stop playing it. I love the fact that you can explore, own, and renovate real houses!"
  },
  {
    id: "didigalt-1",
    rating: 5,
    title: "I just love it!",
    author: "Didigalt",
    date: "2026-03-18",
    content: "Wow such a cool game. I started few days ago and I just can’t stop. Super fund to discover new cities and places"
  },
  {
    id: "jaypthaker-1",
    rating: 5,
    title: "Better than Zillow!",
    author: "jaypthaker",
    date: "2026-03-18",
    content: "Fun to see actual homes and prices in here. Hours of entertainment - way more fun than Zillow scrolling!"
  },
  {
    id: "zisemianbao-1",
    rating: 5,
    title: "Amazing game!",
    author: "zisemianbao",
    date: "2026-02-24",
    content: "I’ve only ever dealt with one glitch in game and the developers got back to me very fast! 10/10 I’ve been recommending this game to everyone I know!!"
  },
  {
    id: "gladis-oberkin-1",
    rating: 5,
    title: "Great game",
    author: "gladis oberkin",
    date: "2025-08-21",
    content: "Love, love, love, love, love. Perfect mix between real estate and a fun game."
  },
  {
    id: "chantalp90-1",
    rating: 5,
    title: "Addictif",
    author: "Chantalp90",
    date: "2025-08-15",
    content: "Ce jeu est complètement addictif. De plus, lorsqu’on écrit au support, on obtient une réponse dans un délai super rapide(quelques minutes). Je vous le conseille fortement 🥰"
  },
  {
    id: "n1trocaesar-1",
    rating: 5,
    title: "Renovation limit and hammers",
    author: "N1troCaesar",
    date: "2025-08-11",
    content: "Games has good concept but renovation limit slows down progress and the cost to renovate is really high"
  },
  {
    id: "roievo-1",
    rating: 5,
    title: "Nouvelle MÀJ INCROYABLE !",
    author: "RoiEvo",
    date: "2025-08-02",
    content: "Le jeu était plaisant avant cette nouvelle mise à jour, mais il est maintenant très amusant à jouer. La difficulté accrue et la meilleure longévité du jeu en font une expérience encore plus captivante. De nombreux joueurs et joueuses ont donné des recommandations qui ont été prises en compte et appliquées par les développeurs. Je suis au courant de la vision des développeurs pour l’avenir du jeu, et je peux vous dire que nous ne sommes qu’au début d’un jeu incontournable!"
  },
  {
    id: "lovemycoffeeyeah-1",
    rating: 5,
    title: "Dang",
    author: "LoveMyCoffeeYeah",
    date: "2025-07-29",
    content: "I hardly pay for games but u just did for this one… dang it’s too much fun lol👍🏻"
  },
  {
    id: "coutu928-1",
    rating: 4,
    title: "Update",
    author: "Coutu928",
    date: "2025-07-28",
    content: "For some reason when it updated it ruined the leaderboard and I can’t see where I am"
  },
  {
    id: "reena-jean-1",
    rating: 5,
    title: "Love Love Love!",
    author: "Reena Jean",
    date: "2025-07-25",
    content: "I love this game so much! The team behind the game has been amazing in every interaction I’ve had and seen, the game is incredibly fun and once you get going it is exciting to see how much progress you can really make - and how much money you earn 🤩  Overall, I 100% recommend this game!! It’s been a great time! It can be hard to get into at first because it takes time to progress but once you progress (obviously the more you play the faster that happens haha) it becomes even more captivating in my opinion!"
  },
  {
    id: "prolly-a-bad-game-1",
    rating: 5,
    title: "Actually Fantastic.",
    author: "Prolly-a-bad-game.",
    date: "2025-07-21",
    content: "The team is good, the game is fun if you like real estate or even just usually like one of those “landlord” type games.  I wouldn’t say it’s reallllyy free to play. While I tend to like games where purchasing something is more of a tip, (and less of a prerequisite because that excludes a lot of players) I did end up purchasing a month of premium because it seems like the game doesn’t really favour whales, and a week in, I believe this game is worth $40 a year if you can afford it."
  },
  {
    id: "aj324167bba7-1",
    rating: 5,
    title: "Amazing",
    author: "aj324167bba7",
    date: "2025-07-16",
    content: "Great game with amazing customer service."
  },
  {
    id: "deesabird69-1",
    rating: 5,
    title: "House Hunter Fanatic",
    author: "DeesABird69",
    date: "2025-07-09",
    content: "My whole life I have really enjoyed house hunters and looking at listings, once this game started popping up on social media accounts I had to give it a try!! A feature on my app had a glitch and their support staff emailed me let me know it was fixed and also added some “speed ups” to my account. Thank you Ankith (who emailed me). I would deff recommend this game for anyone who enjoys looking at listings :)"
  },
  {
    id: "shellz67x-1",
    rating: 5,
    title: "Fun game",
    author: "Shellz67x",
    date: "2025-07-08",
    content: "I love this game. I buy a house cuz I wanna keep it but after I renovate it’s sell sell sell."
  },
  {
    id: "azzzak-1",
    rating: 5,
    title: "Great game",
    author: "azzzak",
    date: "2025-07-07",
    content: "Can’t wait to see for features/cities!"
  },
  {
    id: "xsam11x-1",
    rating: 4,
    title: "Can you fix it fast ?",
    author: "Xsam11x",
    date: "2025-07-06",
    content: "There is a bug with the renovations they are normally finished but when we click on see it marks to wait one more minute and it gives that instead of waiting 3 hours we have to wait several hours or days"
  },
  {
    id: "zoeemmalee-1",
    rating: 4,
    title: "Money stays in city",
    author: "Zoeemmalee",
    date: "2025-06-18",
    content: "The money is separate city to city… it should be combined."
  },
  {
    id: "alexray663-1",
    rating: 4,
    title: "Fun great game",
    author: "Alexray663",
    date: "2025-05-31",
    content: "The game is really fun and gives you a fun taste of the relistate world the only flaw I find is with the hammers there so hard to get and expensive to buy As well I wish there was more ways to get them"
  },
  {
    id: "moni4490-1",
    rating: 4,
    title: "Quicker renovations",
    author: "Moni4490",
    date: "2025-05-27",
    content: "I love this game and I am quite competitive so I usually feel motivated to pursue. I was hoping that renovations can be 6 hours tops. I think 14-20hrs to complete is a little much."
  },
  {
    id: "seg0632-1",
    rating: 4,
    title: "Great game- some additions needed",
    author: "Seg0632",
    date: "2025-05-22",
    content: "I really enjoy playing this game! I would love to see a feature where you can see all your current renovations/homes for sale/homes owned per city. Would really help stop having to tap around to remember. Also, I feel like some of the waiting times are a little too long. I know they persuade in game purchases- but I feel it stops me from playing the game as frequently as I'd like to."
  },
  {
    id: "emilieemyy-1",
    rating: 4,
    title: "Great game BUT",
    author: "Emilieemyy",
    date: "2025-05-21",
    content: "It’s my favourite game. I’m ranked pretty high on it and I paid to have the pro version BUT the game lag so bad now that I have over a thousand rent to collect. The game bug when I try to buy some house. Sometimes it doesn’t even give my my rent. I can’t tour anymore cause the game lag and I can’t even see the houses. I’m so sad 😿"
  },
  {
    id: "skekekksksnssn-1",
    rating: 4,
    title: "Love the game but very disappointed",
    author: "skekekksksnssn",
    date: "2025-05-20",
    content: "Money you make in one city and the hammers should transfer over. Finished my first city but now feeling very unmotivated to continue"
  },
  {
    id: "layllllaaaaa-1",
    rating: 4,
    title: "Fun game but",
    author: "layllllaaaaa",
    date: "2025-04-25",
    content: "I love this game, it’s fun and I check it daily, but it’s getting really annoying how it automatically goes to the new city I unlocked when I open the app. I wish it would open with the city I previously had on. I haven’t worked on my new city I am working on my old and it’s annoying having to go back"
  },
  {
    id: "jimmypotato123-1",
    rating: 4,
    title: "Would pay for this…",
    author: "JimmyPotato123",
    date: "2025-03-29",
    content: "I would pay for this game if it were cheaper (not $40/year) and a lifetime subscription. Really great game so far just takes so long to reload. I think if the game were like $10 for lifetime, I as well as my friends would pay for it."
  },
  {
    id: "mrdynamo-1",
    rating: 4,
    title: "Fun but only focuses on a few cities",
    author: "Mr.Dynamo",
    date: "2025-03-20",
    content: "It would be great if there were more cities. I think for smaller cities with fewer listings you could lump them in with larger markets. It’s a great way to follow prices; though I don’t know if these are closing prices or asking prices. Closing prices would be more interesting to me. Clareity, the company which runs MLS, might be a good parter as a data source for this game if they are open to it."
  },
  {
    id: "thomasln03-1",
    rating: 4,
    title: "Can be better…",
    author: "Thomasln03",
    date: "2025-03-01",
    content: "I think that It was better when you could fill lives with the keys. And, the money should be the same (like the same amount of money in all cities, not separate)"
  },
  {
    id: "anonymous24256-1",
    rating: 5,
    title: "I have a question about the game",
    author: "Anonymous24256",
    date: "2025-02-01",
    content: "How do I place bids on houses?"
  },
  {
    id: "fwtxjarrail-1",
    rating: 4,
    title: "A good game",
    author: "Fwtx_jarrail",
    date: "2025-02-01",
    content: "Run out if hearts so fast"
  },
  {
    id: "lex5437-1",
    rating: 4,
    title: "Please add Som stuff",
    author: "Lex5437",
    date: "2025-01-29",
    content: "It will be nice to upgrade our houses! Also, an the option to bid like auction for buying houses will be great  Adding a filter option (starter, luxury….) for selecting what house to buy (if you have 89 houses to buy it will be more effective.  Adding taxes or deductions or loans can be an good upgrade   But it’s a very nice and addictive game. I recommend it"
  },
  {
    id: "reviewer45f-1",
    rating: 5,
    title: "Networth",
    author: "Reviewer45f",
    date: "2025-01-28",
    content: "Sometimes I buy a house and it dosent add to my networth and it happens lots of time when I buy starter house to billionaire houses still good game"
  },
  {
    id: "jiji-1",
    rating: 5,
    title: "Fun!",
    author: "ji.ji",
    date: "2025-01-11",
    content: "It’s really fun and I like how it’s real-time prices. I think it would be really cool to add player profiles that you can view with the houses they’ve bought, or being able to add your favorite houses to your profile, etc (for a more customized social experience in the game). I haven’t all stars yet on my city so I’m not sure if you can move on to cities/houses all over the world after, but I think that might also be a fun addition!"
  },
  {
    id: "mikolbt-1",
    rating: 4,
    title: "Great Game",
    author: "MikoLbt",
    date: "2025-01-08",
    content: "I love this game, I really can't wait to be able to renovate the properties. So far I haven't had any problems even though I've only been playing for two days. I can't wait to see what's new in the game. There's a lot of potential"
  },
  {
    id: "shbubbies923-1",
    rating: 5,
    title: "User Name: Bobbyjane",
    author: "Shbubbies923",
    date: "2025-01-05",
    content: "My app says s frozen and have turned off the phone several times. If I delete app assuming I’ll lose everything"
  },
  {
    id: "itsthedemonsteel-1",
    rating: 4,
    title: "good game but...",
    author: "ItsTheDemonSteel",
    date: "2024-12-26",
    content: "I have been playing it for a couple weeks now and its pretty fun, one thing that is disappointing is that you cant change your major city (toronto, calgary, vancouver, etc) once you have selected it. I would love to have just switch between the cities, especially if i have already fully completed one city.  Another thing I am disappointed about was the fact that you combined cities, vaughan, newmarket, aurora, and stouffville got put into one, oakville and milton go put into one, the whole of durham is one. i think that if you didnt combine it would make it more realistic and fun. Again, good game, but it could be even better."
  },
  {
    id: "lil-ecca-1",
    rating: 4,
    title: "good game",
    author: "lil ecca",
    date: "2024-12-19",
    content: "just fully completed my city and I’m kinda disappointed because it seems like there’s no more progression past this point. otherwise fun game. I experienced a couple glitches where the “higher or lower” game was set to the price of the house so it was always incorrect."
  },
  {
    id: "atl-nate-1",
    rating: 5,
    title: "losing money after tours",
    author: "atl nate",
    date: "2024-12-12",
    content: "the game is really fun and i’ve been playing it a lot recently but after tours i’ve been losing money so it’s hard to progress anymore"
  },
  {
    id: "blune72-1",
    rating: 5,
    title: "Really fun game!",
    author: "blune72",
    date: "2024-12-11",
    content: "I would’ve been scrolling through Zillow anyways but this makes it fun.   I just wish there was a way to look at apartments and switch between different cities to explore what the housing stock is like over there."
  },
  {
    id: "polio-dolio-1",
    rating: 5,
    title: "Lot size",
    author: "Polio dolio",
    date: "2024-12-05",
    content: "Great game, would love to see the lot size for more accurate pricing"
  },
  {
    id: "klols12-1",
    rating: 5,
    title: "Update request",
    author: "Klols12",
    date: "2024-12-02",
    content: "If you own around 100 properties in one section, the game crashes when opened. I think it has too many images and data to open and overloads the phone."
  },
  {
    id: "lucng1810-1",
    rating: 5,
    title: "great but more features?",
    author: "Lucng1810",
    date: "2024-11-27",
    content: "great game, but i wish there has new feature of housing market price changing depends on periods, or house flipping."
  },
  {
    id: "fubctivk-1",
    rating: 4,
    title: "Fun game but could use a bit more love",
    author: "fubctivk",
    date: "2026-02-19",
    content: "Very fun game and concept! Its a bit annoying though when you want to buy multiple houses, every time you buy a house it send you to \"My houses\" so you have to go back to \"buy\" and filter for the type and scroll for 100 houses to buy the one right next to the one you just bought. It would save a lot of time if we could continue shopping from where you were or buy multiple houses at a time. It would also be nice if we could filter houses based on the price, like if we could put \"lowest to highest\" and the other way around if needed. It would save a lot of time and would make the game feel more complete and less \"AI generated\". And lastly, when you tour, the new houses you've unlocked get put at the end of the list in buy, so you have to scroll trough all the houses you don't want just to see if the new ones are worth buying, would be nice if they appeared at the start. Other than those small inconvenience, the game is great."
  },
  {
    id: "b0b30-1",
    rating: 4,
    title: "House hunt app",
    author: "B0b3.0",
    date: "2025-12-16",
    content: "Il faudrait ajouter section avec tous les maison ajouter en favori disponible lorsqu'on click sur Profil"
  },
  {
    id: "gatorsmomma-1",
    rating: 4,
    title: "It's good but takes too long",
    author: "Gatorsmomma",
    date: "2025-12-04",
    content: "I like the game but it takes way too long to collect hammers to do anything. That's honestly my only complaint with the game."
  },
  {
    id: "nickvxi-1",
    rating: 4,
    title: "So far so good",
    author: "Nickvxi",
    date: "2025-11-09",
    content: "Hope you don't add too much advertisement and keep it going. Already forcing the subscription a little bit too much. I feel like the game needs to have its integrity"
  },
  {
    id: "tattoshoots-1",
    rating: 5,
    title: "Curiosity",
    author: "tatto_shoots",
    date: "2025-11-06",
    content: "At the moment I'm at level 25. I started in Quebec/montreal area and I'm curious as to if the map will show me new locations that I can buy and sell in or if whatever original city you chose is where you stay. I want to add also that it would be cool to buy some of those vacation properties"
  },
  {
    id: "taha128-1",
    rating: 5,
    title: "Awesome support",
    author: "Taha128",
    date: "2025-09-24",
    content: "Solved my issue quickly through the discord channel!"
  },
  {
    id: "amandadar-1",
    rating: 5,
    title: "Something different than social media",
    author: "AmandaDar",
    date: "2026-01-03",
    content: "Enjoyable way to pass time."
  },
  {
    id: "ebazigzeihizrbk-1",
    rating: 5,
    title: "Househunt",
    author: "ebazigzeihizrbk",
    date: "2025-12-28",
    content: "I love this game it so much fun it like actual buying house there they give you actual houses to look at and renovate"
  },
  {
    id: "nikilynn26-1",
    rating: 5,
    title: "good game",
    author: "nikilynn26",
    date: "2025-12-23",
    content: "super fun could reload quicker"
  },
  {
    id: "gdgold-1",
    rating: 5,
    title: "Renovation bugs (pending fix)",
    author: "GdGold_1",
    date: "2025-11-23",
    content: "When I renovate a house the max property value added is $999,999 even though it says 800k-2.1M no matter what I do I can't get more than 999k value added to my house after a renovation"
  },
  {
    id: "colormycrazy-1",
    rating: 4,
    title: "I need help!",
    author: "Colormycrazy",
    date: "2025-11-22",
    content: "Just started playing a couple of days ago and really enjoying the ease of play, and being able to leave it for hours at a time. There's the odd glitch while touring but nothing big, the part I'm frustrated with and needing some help is since I've leveled up to teams and joined one, one of the neighborhoods I was playing is currently controlled by my team but before I joined. Now when I enter that area it tells me to collect the tax but when I try it says I can't because I can after they got control and then my game screen freezes and I have to close out and reenter game but can't go back to that area, I can collect with the mass collect option because I can stay out of the area but thats it. Doesn't make sense and I think it's just a bug. I tried leaving team and going on another one but doesn't change the outcome, I've just kind of lost that neighborhood. Anyone able to fix this?"
  },
  {
    id: "simaotuga007-1",
    rating: 5,
    title: "Amazing Game",
    author: "SimãoTuga007",
    date: "2025-11-11",
    content: "I'm addicted to this game, and on top of that they have an amazing discord that they will answer any question. Keep up the good work!!"
  },
  {
    id: "meganbenn-1",
    rating: 5,
    title: "Totally recommend!",
    author: "meganbenn",
    date: "2025-11-11",
    content: "This game is so amazing! I hear about it and then I decided to download it and holy it's so much fun!"
  },
  {
    id: "aytcharlo-1",
    rating: 5,
    title: "Really good support & game",
    author: "Aytcharlo",
    date: "2025-11-04",
    content: "The support was really helpful for random questions I had, they replied wayy faster than I thought. The game has paid features but you can get good really quick without spending any irl money. Honestly best mobile game"
  },
  {
    id: "grassycole-1",
    rating: 5,
    title: "Great",
    author: "grassycole",
    date: "2025-11-02",
    content: "Love this app. Challenging at times but as it's a new app I'm sure things will grow and progress. Looking forward to seeing what comes out."
  },
  {
    id: "student-most25-1",
    rating: 5,
    title: "Student",
    author: "Most_25",
    date: "2025-10-15",
    content: "As a person who will own many properties and make it big in the real estate property. This game will give me insights into the market while I am simultaneously having fun. Thank you for this game."
  },
  {
    id: "qwertyuiop092829-1",
    rating: 5,
    title: "Awesome",
    author: "Qwertyuiop092829",
    date: "2025-09-26",
    content: "One of the best games I've played thus far. You might be checking your game more often as it is addictive lol. 10/10 recommend."
  },
  {
    id: "mynameiswhoknows-1",
    rating: 5,
    title: "So fun",
    author: "Mynameiswhoknows",
    date: "2025-09-25",
    content: "Top 5 games of all time."
  },
  {
    id: "yaakovcassa-1",
    rating: 5,
    title: "Great game, Great devs",
    author: "YaakovCassa",
    date: "2025-09-06",
    content: "Game is 10/10, devs respond and fix issues super quickly."
  },
  {
    id: "kitty20055-1",
    rating: 4,
    title: "Great game",
    author: "Kitty20055",
    date: "2025-09-06",
    content: "I like the game but wait times are too long, renovations should take max maybe 2 hours, and rent times should also go down. Would be much more enjoyable"
  },
  {
    id: "mrbamboclat-1",
    rating: 5,
    title: "Best mobile game ever",
    author: "Mr. Bamboclat",
    date: "2025-08-22",
    content: "I have tried many mobile games, this is certainly the greatest of them all. Please try it."
  },
  {
    id: "paulm1014-1",
    rating: 5,
    title: "Purchasing and selling information",
    author: "Paul.M.1014",
    date: "2025-08-22",
    content: "This game is really fun, it is a great concept and has a lot of potential. I renovated the kitchen of a house but how come there's only 1 picture of the kitchen (out of 3) that shows the renovation. Shouldn't all the pictures of the kitchen be renovated? Please, developers, I hope you get to see the potential this game has. I would like to suggest to add to a minimum the real life process of purchasing a house (ex: banks, acquiring a loan, the amount cost of a construction company, closing costs, etc). In these real life steps, you can add the explanation that are attached to each steps - this game can potentially give people knowledge when it comes to acquiring houses, industrial buildings and etc! I'm rating this a 5 star not only because of what it is currently but also the potential it has!! Developers, please consider this!!"
  },
  {
    id: "wiggz1-1",
    rating: 5,
    title: "Actual Real Estate Listings make it fun!",
    author: "Wiggz1",
    date: "2025-08-20",
    content: "Fun game with actual real estate listings in your neighborhood and around the world. Fun way to guess house prices and build your empire of houses."
  },
  {
    id: "msisnxie08183017382jsjxbwzhjw-1",
    rating: 5,
    title: "Lowkey dope",
    author: "msisnxie08183017382jsjxbwzhjw",
    date: "2025-08-07",
    content: "This is super dope lol I love it - would love to see Hamilton added near Toronto - hot housing market!"
  },
  {
    id: "agill18-1",
    rating: 5,
    title: "Fun game",
    author: "AGill18",
    date: "2025-08-04",
    content: "It's a fun game and the progression feels rewarding. I had some bugs but the developer always replies fast to fix the issues"
  },
  {
    id: "mikehoncho1991-1",
    rating: 5,
    title: "Addictive",
    author: "Mikehoncho1991",
    date: "2025-08-03",
    content: "Love the game just would enjoy more cities, and maybe make it where you don't have to wait to unlock other cities that's really the only negative I have about this game is being stuck in the same city until I have enough ex.... Let me expand my empire!"
  },
  {
    id: "seafield-1",
    rating: 5,
    title: "new version!",
    author: "seafield",
    date: "2025-07-31",
    content: "i downloaded this app about.. 23 days ago now and the first version i experienced was the easiest, star grabbing, selling-buying, fun game that i didnt mind waiting the time to literally get all my money back from selling and reno's. now the second version, i was torn over. all the money was combined, there were more tasks to reno in certain themes and other goals, and it was harder to get stars and cities. that all quickly grew on me. i'm more eager to get the stars and gain profit on houses before just selling them without making more money (?? that's just silly, i want more money to buy more houses) end all, im excited to come back everyday and get the gifts, keep the streak up, try new designs because of the tasks (i never really used them, or i would just choose modern over gothic revival, for example, which i found is gorgeous, and the annual fee is pretty fair to me 🤷‍♀️ makes everything so much easier without having to click every city to collect income. -seafield"
  },
  {
    id: "accurate-add-1",
    rating: 5,
    title: "Spot on advertisement",
    author: "accurate add",
    date: "2025-10-30",
    content: "Exactly like what the ads described it as, not very many game ads show you how the game is and it actually be like the ad so I actually really like it!"
  },
  {
    id: "natey2111-1",
    rating: 5,
    title: "Great Game",
    author: "Natey2111",
    date: "2025-10-26",
    content: "Really good game I recommend"
  },
  {
    id: "unfrisky-1",
    rating: 5,
    title: "Underrated Gem",
    author: "unfrisky",
    date: "2025-02-22",
    content: "Found this game from a TikTok ad and it's so fun. I love the fact that you can own, renovate, and sell the houses. This game is like if goguessrr and the sims had a child."
  },
  {
    id: "hghsgcndnc-1",
    rating: 5,
    title: "Only App I Have Reviewed",
    author: "Hghsgcndnc",
    date: "2025-02-06",
    content: "This app is truly a 10/10. I have seen some bugs but the dev is SUPER responsive and active and will fix any issues others have said, beyond that this app is very fun and has an awesome future ahead of it. I love the ability to play and buy the houses near my area. Finally I have showed this app to plenty of people age 16-50 and they have all enjoyed playing and downloaded it because of me."
  },
  {
    id: "seper1-1",
    rating: 5,
    title: "Hearts",
    author: "Seper1",
    date: "2025-02-06",
    content: "fun game but should add feature to get hearts easier, maybe pay 1 time fee for unlimited or pay ingame money for hearts."
  },
  {
    id: "mayaa31-1",
    rating: 5,
    title: "great game",
    author: "mayaa31",
    date: "2025-02-03",
    content: "the game is really fun and the creators are super helpful and quick with support if you are having any issues!! i definitely recommend"
  },
  {
    id: "charlottealain-1",
    rating: 5,
    title: "Love it but want more",
    author: "Charlottealain",
    date: "2025-01-30",
    content: "I really love this game, I just finish all of the map in Calgary but I don't have anything to do anymore 😢"
  },
  // Original reviews
  {
    id: "renee-1",
    rating: 5,
    title: "Great game!",
    author: "Renee.W99",
    date: "2025-01-26",
    content: "I downloaded this game about a week ago and I can't get enough! It's the first game I can really get into in a long time! Also the customer service is amazing, fast responses & very nice!"
  },
  {
    id: "rji-1",
    rating: 5,
    title: "Fun!",
    author: "r.ji",
    date: "2025-01-11",
    content: "It's really fun and I like how it has real live updates. I think it would be cool to add player profiles that you can see with the houses they've bought, or being able to add your favorite houses to your profile, etc (for a more customized social experience in the game). I haven't all stars yet on my city so I'm not sure if you can see all to cities/houses all over the world after, but I think that might also be a fun feature!"
  },
  {
    id: "shani-1",
    rating: 5,
    title: "Update request",
    author: "Shani5623",
    date: "2025-01-10",
    content: "Amazing game. When will you be putting in renovations to make our properties more money?"
  },
  {
    id: "awilso-1",
    rating: 5,
    title: "Awesome game!",
    author: "awilso",
    date: "2024-12-06",
    content: "I really love the fact that you can choose your own city! When on tour I sometimes get houses that are a few blocks from my house and it's so fun! Really hope to see this game grow and will keep playing throughout its expansion!"
  },
  {
    id: "hootenpool-1",
    rating: 5,
    title: "Really fun",
    author: "Hootenpool",
    date: "2024-12-03",
    content: "This is the first game I have enjoyed on my phone in a long time. Simple, yet interesting and keeps you wanting to play. I look forward to the renovating feature. I would love to see more of the Okanagan BC, in the game down the road. Lots of interesting real estate here."
  },
  {
    id: "skate72-1",
    rating: 5,
    title: "Really fun game!",
    author: "Skate72",
    date: "2024-12-11",
    content: "I would've been scrolling through Zillow anyways but this makes it fun. I just wish there was a way to look at apartments and switch between different cities to explore what the housing stock is like over there."
  },
  {
    id: "john1841-1",
    rating: 5,
    title: "Best game fr",
    author: "John1841",
    date: "2024-11-27",
    content: "I like how it uses real house and stuff , it's a great game if your bored or even if you want to work as a home seller in Canada ! (GTA )"
  },
  {
    id: "twinsun69-1",
    rating: 5,
    title: "Great very well developed app",
    author: "Twinsun69",
    date: "2024-12-07",
    content: "This game is amazing from the concept to the in-game features like the scroll wheel guessing and the listings/offers, my only issue is there are a few bugs for example if you earn the nightmare stars for a neighborhood and you four house of it, please fix that thanks"
  },
  {
    id: "arravinth-1",
    rating: 5,
    title: "Really fun game",
    author: "Arravinth",
    date: "2025-04-19",
    content: "It's interesting to view the real estate market in each area. You can upgrade the houses and sell for profit! Collect all the properties and increase your net worth! Fun game! Hoping to see more cities added in the future 👌"
  },
  {
    id: "king13-1",
    rating: 4,
    title: "please add more cities",
    author: "king13🙂",
    date: "2025-04-17",
    content: "i love this game so much and i would love if you guys could add Ottawa to the game!"
  },
  {
    id: "mattwiebes-1",
    rating: 5,
    title: "Love it! But needs some work",
    author: "MattWiebes",
    date: "2025-04-10",
    content: "This game is so fun! I love looking at houses so this is the perfect game for me. I've been playing the game for a couple weeks now and have noticed a few things that need fixing. - sometimes when I open the game it doesn't load properly and I can't click anything. - sometimes when I try to collect from only 1 house, it doesn't collect the rent so I have to close the app and try again. - sometimes when I click buy, it says that the houses haven't loaded yet and to check back later Other than that I think the game is great and I can't wait to see what future updates will bring."
  },
  {
    id: "winkcj-1",
    rating: 4,
    title: "Love this game!",
    author: "Winkcj",
    date: "2025-04-02",
    content: "I've recently been playing this game and I really love it! I do wish that we could do a couple of things: - counter offer when we get offers on houses that were trying to sell - it would be nice if we could actually put offers in (I don't know how other offers are coming in from other players because I can never place an offer. I just have to pay whatever the ticket price) - Have more previews of what the AI enhancement will look like for the style I choose. Otherwise it's a really fun game and I love that it's real neighbourhoods in my city. Overall a really fun game!"
  },
  {
    id: "a2farshi12-1",
    rating: 5,
    title: "Very surprised!",
    author: "A2farshi12",
    date: "2025-03-30",
    content: "Yes, a game about real estate sounds like a boring premise. I got this game to try and guess house prices for fun and I was pleasantly surprised with this game. With the idea of real estate, this game absolutely maximized what it could have done. Brilliant job by the developers!"
  },
  {
    id: "evolve3750-1",
    rating: 5,
    title: "Learn about real estate pricing",
    author: "Evolve3750",
    date: "2025-03-30",
    content: "Amazing game excited for teams option Bobbyjane on top Things to add maybe - rewards for tour streaks -other ways to get money (non tour or rent) To developers Keep doing what your doing game is fun to play and educational. Yall are killing it"
  },
  {
    id: "oliviammt-1",
    rating: 5,
    title: "Love it!!",
    author: "oliviammt",
    date: "2025-03-22",
    content: "This game is so much fun I love looking through houses and the incentive to buy and sell to expand makes it really entertaining!! Only thing I would love to see is if you could watch ads to get more hearts cause waiting is brutal!! Love that you guys don't have ads though throughout the game irritating players!"
  },
  {
    id: "mr-r4ph-1",
    rating: 5,
    title: "great game",
    author: "Mr.R4ph",
    date: "2025-05-18",
    content: "Great game honestly no add at all maybe one or two but nothing exaggerated I love to view house price and the interior. I really like this game"
  },
  {
    id: "faith-cormier-1",
    rating: 5,
    title: "I love this",
    author: "Faith Cormier",
    date: "2025-05-17",
    content: "I have so much fun trying too get it right i love it so much"
  },
  {
    id: "housegal-1",
    rating: 4,
    title: "Bookmarking houses",
    author: "House.gal",
    date: "2025-06-29",
    content: "I really love this game , I’ve been playing it nonstop since I got it, my only issue is if you bookmark house i can’t seem to figure out out to see them and the app doesn’t have a support page or questions page unless you have Facebook"
  },
  {
    id: "shatpita-1",
    rating: 5,
    title: "My Opinions After 100h +",
    author: "Shat_Pita",
    date: "2025-06-18",
    content: "First of all this game is a real addiction for those who love games about real estate with a big list of properties and with real picture and price. A lots of update are coming in or haved come by the time you read this. Also a dedicated staff on discord willing to help every players. The only negative is that there isnt a game chat for now."
  },
  {
    id: "lou-1",
    rating: 4,
    title: "Great potential!",
    author: "Lou",
    date: "2025-06-22",
    content: "Looking forward to being able to add friends and more access to cities in Canada"
  },
  {
    id: "brandi-01161-1",
    rating: 5,
    title: "Addictive",
    author: "Brandi-01161",
    date: "2025-06-16",
    content: "Absolutely addictive game ! I finished on city and couldn’t wait to start another. Had a small issue with my account, and got fast service on the weekend! Problem was rectified very quickly. I can’t wait to finish all the cities."
  },
  {
    id: "awalterss-1",
    rating: 5,
    title: "Very addicting and fun",
    author: "awalterss",
    date: "2025-06-12",
    content: "Quite literally one of the only games I’ve downloaded from an instagram ad and it’s actually what I saw. Great game and the support from devs is amazing. Bonus points for no annoying ads every 30 seconds"
  },
  {
    id: "nicknamedbobby-1",
    rating: 5,
    title: "Notifications Offers",
    author: "Nicknamedbobby",
    date: "2025-06-10",
    content: "Love the game but I’m selling my first house and I’m getting notifications for offers. When I go to check the offers it says there’s no offers. Can you fix this?"
  },
  {
    id: "megan204-1",
    rating: 5,
    title: "jeu de rêve!!!",
    author: "megan204",
    date: "2025-06-06",
    content: "Ce jeu est juste wow! Les réalité de la chose rend le jeu encore plus intéressant! De plus, le service « après-vente » est 100%!! Je recommande ce jeu définitivement!!!!"
  },
  {
    id: "tiahotdog-1",
    rating: 5,
    title: "fun",
    author: "Tiahotdog",
    date: "2025-06-05",
    content: "very fun game but idk how to get more hearts when i run out of"
  },
  {
    id: "christine9995-1",
    rating: 5,
    title: "Love this game!",
    author: "Christine9995",
    date: "2025-06-05",
    content: "If you’re like me and you browse real estate sites for fun, this is the game for you! You get to browse real estate listings, guess the prices and earn money and build your profile and unlock new city's! A great way to pass time as well"
  },
  {
    id: "howdycpwboy-1",
    rating: 5,
    title: "so fun",
    author: "howdycpwboy",
    date: "2025-05-26",
    content: "I love to look at houses and this is acc so cute I never leave reviews but this game is so fun!!! also no ads"
  }
]; 